import styled from 'styled-components'

export const Container = styled.div`
  background: rgba(200, 200, 200, 0.2);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(20px);
  position: absolute;
  top: 170px;
  right: 75px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border-radius: 10px;
  @media (max-width: 768px) {
    position: static;
    flex-direction: column;
  }

  /* 
  .react-date-picker__calendar--closed {
    display: block !important;
  } */
`

export const CalendarContainer = styled.div`
  display: flex;
  gap: 1rem;
`
export const FirstCalendarContainer = styled.div`

  }
`
export const SecondCalendarContainer = styled.div`
  }
`
export const DivStyled = styled.div`
   @media (max-width: 768px) {
   display:flex;
   justify-content: right
`
export const CaptionCalendar = styled.div`
  font-size: 1rem;
  padding-bottom: 0.5rem;
  text-align: center;
  font-weight: 600;
`
export const CloseCalendar = styled.button`
  position: absolute;
  font-size: 1rem;
  right: 10px;
  top: 7px;
  padding: 0.5em 0.75rem;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 0.5rem;
  font-weight: bold;
  background: #fe5c73;
  color: white;
  border: none;
  @media (max-width: 768px) {
    position: static;
    align-self: flex-end;
  }
`
export const SelectCalendar = styled.button`
  font-size: 1rem;
  cursor: pointer;
  background: #6ab672;
  color: white;
  border: none;
  align-self: right;
  font-weight: bold;
  border-radius: 5px;
  padding: 0.45em 0.75rem;
  @media (max-width: 768px) {
    position: static;
    align-self: center;
    flex: 2;
  }
`
export const SelectLifeWeek = styled.span`
  right: 1000px;
  top: 7px;

  padding: 0.45em 0.75rem;
  @media (max-width: 768px) {
    position: static;
    align-self: center;
    flex: 2;
  }
`
export const Input = styled.input`
  background: #e8f0f7;
  border: none;
  outline: none;
  //width: 100%;
  flex: 1;
  font-size: 1.2rem;
  padding: 5px;
  color: rgba(0, 0, 0);
  border-radius: 5px;
  @media (max-width: 1024px) {
    font-size: 1rem;
    font-weight: 400;
    padding: 10px;
  }
`
export const InputBar = styled.div`
  background-color: white;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 1rem;
  align-items: center;
`
